import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import { Background } from '@/components/atoms/Background/Background';
import { Card } from '@/components/atoms/Card/Card';
import { CareProviderSearch } from '@/components/molecules/CareProviderSearch/CareProviderSearch';

interface BannerProps {
  bannerImageUrl: string;
}

export const Banner = ({ bannerImageUrl }: BannerProps) => {
  return (
    <Background src={bannerImageUrl} position='0 10%'>
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          m: 0,
          p: 0,
          '@media (min-width: 600px)': { maxWidth: '500px', p: sp[24] },
        }}
      >
        <Card>
          <CareProviderSearch />
        </Card>
      </Box>
    </Background>
  );
};

export default Banner;
